/**
 * Custom element that implements a sticky add to cart component
 * @extends HTMLElement
 */
class StickyAtc extends HTMLElement {
  /**
   * Initialize the sticky ATC component and setup intersection observer
   */
  connectedCallback() {
    this.form = document.querySelector('product-form');
    if (!this.form) return;

    const header = document.querySelector('header');
    const headerHeight = header?.offsetHeight || 0;
    const rootMargin = headerHeight > 0 ? `-${headerHeight}px 0px 0px 0px` : '0px 0px 0px 0px';

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.ariaDisabled = entry.isIntersecting;
      },
      {
        root: null,
        threshold: 0,
        rootMargin,
      }
    );

    this.observer?.observe(this.form);
  }

  /**
   * Cleanup intersection observer when element is removed from DOM
   */
  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('sticky-atc', StickyAtc);
